import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';



@Injectable()
export class DashboardCreateResolver  {
    constructor() { }

    resolve(route: ActivatedRouteSnapshot) {
        return { moduleGroupId: route.paramMap.get('moduleGroupId'), moduleId: route.paramMap.get('moduleId') };
    }
}